import styles from './main.scss';
export default styles;
